import { z } from "zod";

import { IntelligemsRoleList } from "../schemas/intelligems";

export const RoleDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  organizationId: z.string().uuid(),
  roleType: z.enum(IntelligemsRoleList),
  lastLoginTs: z.number().nullish(),
});

export type RoleDto = z.infer<typeof RoleDtoSchema>;
